module.exports = __webpack_public_path__ + "static/img/greeting.7053a1c4.png";